import { useSelector } from 'react-redux';
import { webFormatCurrency, formatOfferExpiryDate } from '@rb-serve-app/core';

export const SupplementaryCardOfferContent = ({ rb_offer }: any) => {
  return (
    <div className="flex-1 flex flex-col justify-center px-6 pb-6">
      <h2
        className="text-[24px] font-[650] text-primary-red mb-2 text-center"
        aria-label={rb_offer?.requestCard?.title}
      >
        {rb_offer?.requestCard?.title}
      </h2>

      <p
        className="text-[16px] font-[450] text-black mb-4"
        aria-label={rb_offer?.requestCard?.webdescription}
      >
        {rb_offer?.requestCard?.webdescription}
      </p>

      <ul className="list-disc list-inside text-sm text-black mb-4 px-2 text-[16px] font-[450]">
        {Object.entries(rb_offer?.requestCard?.descPoints || {}).map(
          ([key, value]) => (
            <li key={key}>{value as string}</li>
          )
        )}
      </ul>

      <p
        className="text-sm text-black mb-4 text-[16px] font-[450]"
        aria-label={rb_offer?.requestCard?.note}
      >
        {rb_offer?.requestCard?.note}
      </p>
    </div>
  );
};
export const ResiOfferContent = ({ rb_offer }: any) => {
  return (
    <div className="flex-1 flex flex-col justify-center px-6 pb-6">
      <h2
        className="text-[24px] font-[650] text-primary-red mb-2 text-center"
        aria-label={rb_offer?.webResiOffer?.title}
      >
        {rb_offer?.webResiOffer?.title}
      </h2>

      <p
        className="text-[16px] font-[450] text-black mb-4"
        aria-label={rb_offer?.webResiOffer?.webdescription}
      >
        {rb_offer?.webResiOffer?.webdescription}
      </p>
    </div>
  );
};

export const BalanceTrfrOfferContent = ({
  rb_offer,
  offerDetails,
  apiOffer,
}: any) => {
  const { accountDetails = {} } = useSelector((state: any) => state.user || {});
  const splittedText = offerDetails?.split(' ');
  const card_no = accountDetails ? accountDetails?.customer?.cardLast4 : 'XXXX';

  // Function to process the new Contentful format
  const processBalanceTransferDescription = (
    description: string,
    apiOffer: any
  ) => {
    if (!description) return '';

    // Replace card number placeholder
    let processedText = description.replace('%s', card_no ?? '');

    // Extract API offer details for replacements
    // if (offerDetails && splittedText.length > 0) {
    // Parse API description: "6 MTHS 0.00% BAL TRANSFER" or "6 MTHS 0.00% BT 1.00% FEE"
    const apiDescription = offerDetails?.trim();

    // Extract months - look for number before MTHS/MTH
    const monthsMatch =
      apiDescription?.match(/(\d+)\s*MTHS?/i) ||
      apiDescription?.match(/(\d+)\s*M?/i);
    const months = monthsMatch ? monthsMatch[1] : '';

    // Extract interest rate - look for percentage before BT or BAL
    const interestMatch = apiDescription?.match(/(\d+\.?\d*%)/);
    const interest = interestMatch ? interestMatch[1] : '0.00%';

    // Extract fee - look for percentage after BT/BAL TRANSFER
    let fee = '0';
    // if (apiDescription.includes('FEE')) {
    const feeMatch = apiDescription?.match(/(\d+\.?\d*%)\s+FEE/i);
    if (feeMatch) {
      fee = feeMatch[1];
    }
    // }

    // Format deadline from API endDate: "2025-12-31" -> "December 31, 2025"
    let formattedDeadline = '';
    if (apiOffer?.offerDetails?.endDate) {
      const locale = (localStorage.getItem('language') || 'en-US') as
        | 'en-US'
        | 'fr';
      formattedDeadline = formatOfferExpiryDate(
        apiOffer.offerDetails.endDate,
        locale
      );
    }

    // Replace dynamic placeholders
    processedText = processedText
      .replace('%(months)s', months)
      .replace('%(interest)s', interest)
      .replace('%(deadline)s', formattedDeadline)
      .replace('%(fee)s', fee === '0' ? '0%' : fee);
    // }

    return processedText;
  };

  const processedDescription = processBalanceTransferDescription(
    rb_offer?.balanceTransfer?.description || '',
    apiOffer
  );

  // Remove \n and <li> tags to keep it all in one paragraph
  const cleanedDescription = processedDescription
    .replace(/\\n/g, ' ') // remove newline characters
    .replace(/<\/?li>/g, '') // remove <li> and </li>
    .trim();

  console.log('BT Offer Details:', {
    splittedText,
    offerDetails,
    processedDescription,
    apiOffer,
  });

  return (
    <div className="flex-1 flex flex-col justify-center px-6 pb-6">
      <h2
        className="text-[24px] font-[650] text-primary-red mb-2 text-center"
        aria-label={rb_offer?.balanceTransfer?.title}
      >
        {rb_offer?.balanceTransfer?.title}
      </h2>

      <div className="text-[15px] font-[450] text-black mb-4 text-center">
        <p>{cleanedDescription}</p>
      </div>
    </div>
  );
};

export const CardLimitIncOfferContent = ({ rb_offer, offer }: any) => {
  const lang = localStorage.getItem('language') || 'en-US';
  const formatExpiryDate = (dateStr: string) => {
    const locale = (localStorage.getItem('language') || 'en-US') as
      | 'en-US'
      | 'fr';
    return formatOfferExpiryDate(dateStr, locale);
  };
  return (
    <div className="flex-1 flex flex-col justify-center px-6 pb-6">
      <h2
        className="text-2xl font-bold text-primary-red mb-2 text-center"
        aria-label={rb_offer?.creditLimit?.title}
      >
        {rb_offer?.creditLimit?.title}
      </h2>

      <p
        className="text-base font-medium text-black mb-4 text-center"
        aria-label={`${rb_offer?.creditLimit?.description}${webFormatCurrency(Number(offer?.cliResponse?.offered_credit_limit), lang)}!`}
      >
        {`${rb_offer?.creditLimit?.description}${webFormatCurrency(Number(offer?.cliResponse?.offered_credit_limit), lang)}!`}
      </p>
      <p
        className="text-base font-medium text-black mb-4 text-center"
        aria-label={rb_offer?.creditLimit?.subText1}
      >
        {rb_offer?.creditLimit?.subText1}
      </p>
      <p
        className="text-base font-medium text-black mb-2 text-center"
        aria-label={rb_offer?.creditLimit?.subText2}
      >
        {rb_offer?.creditLimit?.subText2}
      </p>
      <p
        className="text-xl font-bold text-black mb-4 text-center"
        aria-label={`${webFormatCurrency(Number(offer?.cliResponse?.current_credit_limit), lang)}`}
      >
        {`${webFormatCurrency(Number(offer?.cliResponse?.current_credit_limit), lang)}`}
      </p>
      <p
        className="text-xl font-semibold text-[#D92A1C] mb-2 text-center"
        aria-label={rb_offer?.creditLimit?.subText3}
      >
        {rb_offer?.creditLimit?.subText3}
      </p>
      <p
        className="text-2xl font-bold text-[#D92A1C] mb-4 text-center"
        aria-label={`${webFormatCurrency(Number(offer?.cliResponse?.offered_credit_limit), lang)}`}
      >
        {`${webFormatCurrency(Number(offer?.cliResponse?.offered_credit_limit), lang)}`}
      </p>
      <p
        className="text-base font-medium text-black mb-4 text-center"
        aria-label={`${rb_offer?.creditLimit?.accept} ${formatExpiryDate(offer?.cliResponse?.expiry_date)}`}
      >
        {rb_offer?.creditLimit?.accept}
        {formatExpiryDate(offer?.cliResponse?.expiry_date)}
      </p>
    </div>
  );
};

export const CreditLimitLegalSection = ({ rb_offer }: any) => (
  <div className="text-xs text-gray-600 space-y-3 leading-relaxed">
    {rb_offer?.creditLimit?.disclaimer?.intro && (
      <p aria-label={rb_offer?.creditLimit?.disclaimer.intro}>
        {rb_offer?.creditLimit?.disclaimer.intro}
      </p>
    )}

    {rb_offer?.creditLimit?.disclaimer?.items?.map((item: any, idx: any) => (
      <p key={idx}>
        <strong>{idx + 1}.</strong> {item}
      </p>
    ))}

    {rb_offer?.creditLimit?.disclaimer?.trademarks?.length > 0 && (
      <div className="space-y-1 pt-3">
        {rb_offer?.creditLimit?.disclaimer.trademarks.map(
          (line: any, idx: any) => (
            <p key={idx}>{line}</p>
          )
        )}
      </div>
    )}

    {rb_offer?.creditLimit?.disclaimer?.copyright && (
      <p
        className="pt-2"
        aria-label={rb_offer?.creditLimit?.disclaimer?.copyright}
      >
        {rb_offer?.creditLimit?.disclaimer?.copyright}
      </p>
    )}
  </div>
);

export const RegiLegalSection = ({ rb_offer }: any) => (
  <div className="text-xs text-gray-600 space-y-3 leading-relaxed">
    {rb_offer?.webResiOffer?.legalDisclaimer?.title && (
      <p
        className="font-[500]"
        aria-label={rb_offer?.webResiOffer?.legalDisclaimer?.title}
      >
        {rb_offer?.webResiOffer?.legalDisclaimer?.title}
      </p>
    )}

    <div className="">
      {Object.values(rb_offer?.webResiOffer?.legalDisclaimer?.disclaimer).map(
        (item: any, index: number) => (
          <li key={index}>{item}</li>
        )
      )}
    </div>
  </div>
);
